import { FilterType } from '@/models';
import { translateDynamicKey } from '@/types/translation';
import { useTranslation } from 'react-i18next';

const extraKeys = ['hcpCharacteristic.secondarySpecialty', 'hcpCharacteristic.otherSpecialty'] as const;
type ExtraKey = (typeof extraKeys)[number];

export const FILTER_ADDITIONAL_TEXT_MAP: Partial<Record<FilterType | ExtraKey, string>> = {
  'ta': 'global.filters.additionalFilterLabel.primary',
  'secondarySpecialty': 'global.filters.additionalFilterLabel.secondary',
  'otherSpecialty': 'global.filters.additionalFilterLabel.other',
  'hcpCharacteristic.secondarySpecialty': 'global.filters.additionalFilterLabel.secondary',
  'hcpCharacteristic.otherSpecialty': 'global.filters.additionalFilterLabel.other',
};

export const useGetActiveFilterAdditionalText = (filterKey: FilterType | string): string | null => {
  const { t } = useTranslation();

  const additionalTextTranslationKey = FILTER_ADDITIONAL_TEXT_MAP[filterKey as FilterType];
  if (!additionalTextTranslationKey) return null;
  return translateDynamicKey(t, additionalTextTranslationKey);
};
